export default __webpack_public_path__ + "static/d-sizzling1-1d038dc68931190c1bea4626eacb85bd.jpg";